// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['hr_HR']  = {
  "name": "hr_HR",
  "day": {
    "abbrev": [
      "Ned",
      "Pon",
      "Uto",
      "Sri",
      "Čet",
      "Pet",
      "Sub"
    ],
    "full": [
      "Nedjelja",
      "Ponedjeljak",
      "Utorak",
      "Srijeda",
      "Četvrtak",
      "Petak",
      "Subota"
    ]
  },
  "month": {
    "abbrev": [
      "Sij",
      "Vel",
      "Ožu",
      "Tra",
      "Svi",
      "Lip",
      "Srp",
      "Kol",
      "Ruj",
      "Lis",
      "Stu",
      "Pro"
    ],
    "full": [
      "Siječanj",
      "Veljača",
      "Ožujak",
      "Travanj",
      "Svibanj",
      "Lipanj",
      "Srpanj",
      "Kolovoz",
      "Rujan",
      "Listopad",
      "Studeni",
      "Prosinac"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d.%m.%Y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

